import React from 'react';
import styled from '@emotion/styled';
import OtherBankModal from '../modal/OtherBankModal';
import { useRecoilValue } from 'recoil';
import { otherBankSelectorState } from '../../../../../data/estimate/common/modal/atom';
import useReset from '../../../../../hooks/common/useReset';

const Base = styled.section`
  display: none;
  grid-column: span 6;
`;

/**
 *  타금융할부 모달 영역 컴포넌트
 *  */
function OtherBankArea(): JSX.Element | null {
  // reset
  useReset(otherBankSelectorState);

  // select
  const otherModal: boolean = useRecoilValue(otherBankSelectorState);
  return (
    <>
      {otherModal ? (
        <Base>
          <OtherBankModal />
        </Base>
      ) : null}
    </>
  );
}

export default OtherBankArea;
